@import "@/scss/use-bootstrap-mixins.scss";

// --- Deal Ribbon ---

.ribbon {
  display: flex;
  overflow-x: auto;
  gap: 8px;
  padding: 12px 0;
  -webkit-overflow-scrolling: touch;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.card {
  position: relative;
  min-width: 160px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  background: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
  font-family: inherit;
  text-align: left;

  &:hover {
    border-color: color-mix(in srgb, var(--rs-theme) 50%, #e0e0e0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &.active {
    border-color: var(--rs-theme);
    background: var(--rs-theme-5Pct);
  }

  &:focus-visible {
    outline: 2px solid var(--rs-theme);
    outline-offset: 2px;
  }
}

.checkmark {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #222;
  margin-bottom: 4px;
  line-height: 1.3;
}

.rate {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #111;
  line-height: 1.2;
}

.period {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #888;
  margin-top: 2px;
}

// --- Descriptor Switch Confirm Bar ---

.confirmBar {
  overflow: hidden;
  border-radius: 8px;
  background: var(--rs-theme-5Pct);
  margin: 8px 0;
}

.confirmContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  gap: 12px;
  flex-wrap: wrap;

  @include media-breakpoint-down(sm) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.confirmText {
  display: flex;
  flex-direction: column;
  gap: 2px;

  > span:first-child {
    font-size: 14px;
    font-weight: 600;
    color: #222;
  }
}

.confirmNote {
  font-size: 12px;
  font-weight: 400;
  color: #888;
}

.confirmButtons {
  display: inline-flex;
  gap: 8px;
  flex-shrink: 0;
}

.cancelButton {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  border: 1.5px solid #ccc;
  background: transparent;
  color: #444;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: #999;
    color: #222;
  }
}

.confirmButton {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  border: 1.5px solid var(--rs-theme);
  background: var(--rs-theme);
  color: var(--rs-text-on-primary, #fff);
  cursor: pointer;
  font-family: inherit;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
}
